module.exports = __webpack_public_path__ + "static/media/concept.100e8ef9.svg";